import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Expand = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9999 7.00009C12.9999 7.27623 13.2237 7.50009 13.4999 7.5001C13.776 7.5001 13.9999 7.27625 13.9999 7.00011L14 2.50001C14 2.3674 13.9473 2.24022 13.8535 2.14645C13.7598 2.05268 13.6326 2 13.5 2H8.99989C8.72375 2 8.49989 2.22386 8.49989 2.5C8.49989 2.77614 8.72375 3 8.99989 3L12.2929 3L8.64634 6.64654C8.45108 6.8418 8.45108 7.15838 8.64634 7.35364C8.8416 7.5489 9.15818 7.5489 9.35344 7.35364L13 3.70713L12.9999 7.00009ZM3.00017 8.99997C3.00017 8.72382 2.77632 8.49997 2.50018 8.49996C2.22403 8.49996 2.00017 8.72381 2.00017 8.99996L2.00012 13.5001C2.00012 13.6328 2.0528 13.7599 2.14657 13.8537C2.24034 13.9475 2.36751 14.0001 2.50012 14.0001H7.00031C7.27645 14.0001 7.50031 13.7763 7.50031 13.5001C7.50031 13.224 7.27645 13.0001 7.00031 13.0001H3.70723L7.35386 9.35351C7.54912 9.15825 7.54912 8.84167 7.35386 8.64641C7.1586 8.45114 6.84202 8.45114 6.64676 8.64641L3.00013 12.293L3.00017 8.99997Z"
        fill={color}
      />
    </svg>
  )
})

export default Expand
